module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.e044ed2.eot";